import type { UseAtAGlanceResult } from '../at-a-glance/useAtAGlance.ts';

import { createPanelDataBridge, type PanelDataBridge } from './createPanelDataBridge.ts';

export type AtAGlanceBridgeData = {
	contentId: string | undefined;
	atAGlance: UseAtAGlanceResult;
};

export const initialAtAGlanceBridgeData: AtAGlanceBridgeData = {
	contentId: undefined,
	atAGlance: { output: null, loading: true, error: null },
};

// BylineConnections is the sole producer. Readers never fetch or hydrate this stream.
const bridge: PanelDataBridge<AtAGlanceBridgeData> = createPanelDataBridge(
	initialAtAGlanceBridgeData,
);

export const publishAtAGlance: typeof bridge.publish = bridge.publish;
export const clearAtAGlance: typeof bridge.clear = bridge.clear;
export const useAtAGlanceData: typeof bridge.useValue = bridge.useValue;
export const clearAtAGlanceForTesting: typeof bridge.clearForTesting = bridge.clearForTesting;
